var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon && _vm.text)?_c('div',{staticClass:"cm-list-title",class:( _obj = {}, _obj[("list-title-" + _vm.size)] = _vm.size, _obj )},[(_vm.icon)?_c('img',{staticClass:"icon-title",attrs:{"src":_vm.icon,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }